<script>
    import { required, minLength } from "vuelidate/lib/validators";
    import General from '@/services/General';
    import validationMessages from '@/components/validations'

    export default {


        props: {
            item: {
                type: [Array, Object],
                default: null,
            },

        },

        components:{
            validationMessages
        },

        data() {
            return {
                csrf_token: localStorage.getItem('csrf_token'),
                demandOptions: ['delete'],
                demand: '',
                source: 'dashboard',
                showModal: false,
                tryingToEdit: false,
                submitted: false,
                showInRegister: '1' ,
                parent: '',
                text : '' ,
                phone : '' ,
                email : '' ,
                uniqueSet: '' ,
                language : '' ,
                name : '' ,
                default_description : '' ,
                optInID: '',
                description : '' ,
                RemoveOptIns : '' ,
                selectedParent: null,


            };
        },
     validations : {

         description : {
             required,
             minLength: minLength(2)
         }  ,

       language : {
            required
         }

     } ,


        methods: {
          syncData(){
            console.log(this.item,'item in modal data add')
            this.default_description = this.item.description
            this.optInID = this.item.id

          },

            async addCrmOptInTranslation(){
                this.tryingToEdit = true;
                this.submitted = true;
                this.$v.$touch()
                if (this.$v.$invalid) {
                    this.tryingToEdit = false;
                    return;
                } else {

                  const formData = {
                    localization: [
                      {
                        description: this.description,
                        language: this.language,
                        action: "add"
                      }
                    ]
                  };

                    try {
                        await General.addCrmOptInTranslation(formData,this.optInID).then((response) => {
                            this.successmsg("Request has been saved");
                            this.closeModal();
                        }).catch(error => {
                            this.error = error.response.data.error ? error.response.data.error : "";
                            this.failedmsg("Request not saved")
                        }).finally(() => {
                            this.refreshData()
                            this.tryingToEdit = false;
                        })
                    } catch (error) {
                        this.error = error.response.data.error ? error.response.data.error : "";
                        this.failedmsg("Request not saved")
                    }
                }
                this.tryingToEdit = false;
            },


            resetProps(){
                this.name= '';
                this.description= '';
                this.language= '';
                this.parent = '' ;
                this.tryingToEdit = false;
                this.submitted = false;
            },

            uniqueParents() {
                if (this.item && Array.isArray(this.item)) {
                    const uniqueSet = new Set(this.item.map(data => data.name));
                    return Array.from(uniqueSet);
                }
                return [];
            },
            refreshData() {
                this.$emit('onRefresh')
            },


          closeModal() {
                this.showModal = false;
            },
        }
    };
</script>

<template>
    <b-modal @shown="syncData" v-model="showModal" id="add_optin_translation" @hidden='resetProps()' title="Add Opt Ins Translations" title-class="font-18" centered>
        <form @submit.prevent="addCrmOptInTranslation">

            <b-form-group label="Language" label-for="language">
              <select v-model="language" class="form-select" :class="{
                                          'is-invalid': submitted && $v.language.$error,
                                        }">
                <option   value="nl">NL</option>
                <option   value="en">EN</option>
                <option   value="fr">FR</option>
              </select>
              <validationMessages v-if="submitted" :fieldName="'Language'" :validationName="$v.language"></validationMessages>

            </b-form-group>
          <b-form-group label="Default Description" label-for="formrow-description-input" class="mb-3">
            <b-form-input
                v-model.trim="default_description"
                type="text"
                id="default_description"
                aria-describedby="name-feedback"
                disabled
            >
            </b-form-input>

          </b-form-group>
            <b-form-group label="Description" label-for="formrow-description-input" class="mb-3">
                <b-form-input
                        v-model.trim="description"
                        type="text"
                        id="description"
                        aria-describedby="name-feedback"
                        :class="{
                                          'is-invalid': submitted && $v.description.$error,
                                        }"
                >
                </b-form-input>
                <validationMessages v-if="submitted" :fieldName="'Description'" :validationName="$v.description"></validationMessages>

            </b-form-group>


            <input type="hidden" name="csrf_token" v-model="csrf_token">
        </form>

        <template v-slot:modal-footer>
            <b-button variant="light" @click="closeModal">Close</b-button>
            <b-button variant="primary" @click="addCrmOptInTranslation" :disabled="tryingToEdit">
                <b-spinner v-show="tryingToEdit" small></b-spinner>
                Submit</b-button>
        </template>
    </b-modal>
</template>